import { render, staticRenderFns } from "./NewBadge.vue?vue&type=template&id=127f2250&scoped=true&"
import script from "./NewBadge.vue?vue&type=script&lang=js&"
export * from "./NewBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f2250",
  null
  
)

export default component.exports